import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import {
  ICustomer,
} from 'src/app/features/customers/models/customers.models';
import { Store } from '@ngrx/store';
import { AppState } from 'src/app/core/app.state';
import { Observable, Subject, takeUntil } from 'rxjs';
import { IAgent } from 'src/app/features/agents/models/agents.models';
import * as agentsActions from '../../../../store/agents.actions';
import { Actions, ofType } from '@ngrx/effects';

@Component({
  selector: 'app-agent-portfolio-add-dialog',
  templateUrl: './agent-portfolio-add-dialog.component.html',
  styleUrls: ['./agent-portfolio-add-dialog.component.scss'],
})
export class AgentPortfolioAddDialogComponent implements OnInit {
  agent: IAgent | null = null;
  subsidiaryId: number | null = null;

  customers$: Observable<ICustomer[]> = this.store.select(
    (state) => state.customers.customers
  );
  customers: ICustomer[] = [];
  initialSelectedLocations: number[] = [];
  locations_ids: number[] = [];

  filter: any | undefined = undefined;
  unparsedFilter: any | undefined = undefined;

  destroy$ = new Subject<void>();

  constructor(
    private store: Store<AppState>,
    private dialogRef: MatDialogRef<AgentPortfolioAddDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private actions$: Actions
  ) {}

  ngOnInit(): void {
    this.initialSelectedLocations = this.data.locations_ids;
    this.locations_ids = this.initialSelectedLocations;

    this.agent = this.data.agent;
    this.subsidiaryId = this.data.subsidiary_id ?? null;

    console.log("Subsidiary ID: ", this.subsidiaryId);
    
    this.actions$.pipe(
      ofType(agentsActions.UpdateAgentSuccess),
      takeUntil(this.destroy$)
    ).subscribe((action) => {
      this.dialogRef.close();
    });
  }

  selectedLocationsChange(locations: number[]) {
    this.locations_ids = locations;
  }

  companiesSelected(companies: ICustomer[]) {
    this.customers = companies;
  }

  save() {
    if (this.initialSelectedLocations === this.locations_ids) return;
    if(this.data.type === 'client') {
      const result = {
        customers: this.customers,
        locations_ids: this.locations_ids
      }
      this.dialogRef.close(result);
      return;
    }
    if (!this.agent?.id) return;
    this.store.dispatch(agentsActions.UpdateAgent({
      id: this.agent.id!,
      agent: { location_ids: this.locations_ids }
    }));
  }

  cancel() {
    this.dialogRef.close();
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }
}
